import { getGender, type Gender } from 'lib/gender-detection';

export type AvatarBucket = 'male' | 'female' | 'neutral';

// Must match the actual file count in each subfolder of
// `public/assets/images/avatar/{male,female,neutral}/`. Wrong counts → 404s.
const AVATAR_COUNTS: Record<AvatarBucket, number> = {
  male: 5,
  female: 6,
  neutral: 3,
};

const bucketFor = (gender: Gender): AvatarBucket =>
  gender === 'male' ? 'male' : gender === 'female' ? 'female' : 'neutral';

const hashCharCodes = (s: string): number =>
  Math.abs([...s].reduce((a, c) => a + c.charCodeAt(0), 0));

/**
 * Deterministic avatar URL. Same id → same avatar, even if the name changes.
 * Pass `name` to route to a gender-matched bucket; omit it to get neutral.
 */
export const getAvatarUrl = (id: string, opts?: { name?: string | null }): string => {
  const bucket: AvatarBucket = opts?.name ? bucketFor(getGender(opts.name)) : 'neutral';
  const count = AVATAR_COUNTS[bucket] || AVATAR_COUNTS.neutral;
  const safeId = id || 'anonymous';
  const idx = (hashCharCodes(safeId) % count) + 1;
  return `/assets/images/avatar/${bucket}/${idx}.webp`;
};
